import { render, staticRenderFns } from "./RelayPoints.view.vue?vue&type=template&id=de63024c&"
import script from "./RelayPoints.view.vue?vue&type=script&lang=js&"
export * from "./RelayPoints.view.vue?vue&type=script&lang=js&"
import style0 from "./RelayPoints.view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports